module.exports = __webpack_public_path__ + "img/api-serve.bf0a25a3.png";